import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PreinvoiceListComponent } from './preinvoice-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PreinvoiceService } from './preinvoice.service';
import { ConceptService } from '../../concept/concept/concept.service';

@Component({
    selector: 'convfact-barcode-dialog',
    templateUrl: './barcode-dialog.component.html',
    styleUrls: ['./barcode-dialog.component.css'],
    standalone: false
})
export class BarcodeDialogComponent {
    error_msg: string;
    error: boolean = false;
    barcode: string = "";

    constructor(
        public dialogRef: MatDialogRef<PreinvoiceListComponent>,
        public snackBar: MatSnackBar,
        public preinvoiceService: PreinvoiceService,
        public conceptService: ConceptService
    ) { }

    scanBarcode() {
        this.conceptService.barcode(this.barcode).then(response => {
            const data = { concept: response, serialNumber: false };
            if (response['serialNumber']) {
                data['serialNumber'] = true;
            }
            if (data['concept']) {
                this.dialogRef.close(data);
            } else {
                this.error = true;
                this.error_msg = "No se ha encontrado ningún concepto con ese código de barras";
            }
        })
    }

    onKeyUp(event: KeyboardEvent): void {
        // Verifica si la tecla Enter ha sido presionada
        if (event.key === 'Enter') {
            event.preventDefault(); // Previene el envío del formulario
            this.scanBarcode(); // Llama a tu función con el valor escaneado
        }
    }

}